// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610111728/js/" + chunkId + "." + {"44":"00d8c670","225":"aae7358a","481":"4136148d","486":"c8946c8b","770":"cc8be009"}[chunkId] + ".0.42687157239326334.chunk.js";
};